import { useState, useCallback } from 'react';
import { resolveEffectiveTheme, toggleTheme, DARK } from './themeHelper';

// Thin hook over themeHelper: exposes the current dark state and a toggle.
export default function useTheme() {
  const [theme, setThemeState] = useState(() => resolveEffectiveTheme());

  const toggle = useCallback(() => {
    setThemeState(toggleTheme());
  }, []);

  return { isDark: theme === DARK, toggle };
}
